import React from 'react';
import { Card, CardImg, CardText, CardBody, CardTitle, CardSubtitle } from 'reactstrap';
import { Loading } from './LoadingComponent';
import { baseUrl } from '../shared/baseUrl';

export default ({ item, isLoading, errMessage }) => {
    if (isLoading) {
        return (
            <Loading />
        );
    }
    else if (errMessage) {
        return (
            <h4>{errMessage}</h4>
        );
    }
    else {
        return (
            <Card>
                <CardImg src={`${baseUrl}${item.image}`} alt={item.name} />
                <CardBody>
                    <CardTitle>{item.name}</CardTitle>
                    {item.designation ? <CardSubtitle>{item.designation}</CardSubtitle> : null}
                    <CardText>{item.description}</CardText>
                </CardBody>
            </Card>
        );
    }
}